<template>
  <b-card no-body>
    <b-card-body
      class="py-2 d-flex flex-column justify-content-center align-items-center"
    >
      <div
        class="w-100 d-flex justify-content-center align-items-center pb-2 position-relative"
      >
        <b-skeleton
          v-if="loading"
          width="117px"
          height="117px"
          class="rounded-avatar"
        />
        <template v-else>
          <b-img
            :src="
              userData.avatar
                ? userData.avatar
                : userData.gender == 'MALE'
                ? require('@/assets/images/fxlegends/172625_male_user_icon.svg')
                : userData.gender == 'FEMALE'
                ? require('@/assets/images/fxlegends/172621_user_female_icon.svg')
                : errorImage
            "
            @error="setAltImg"
            style="border: 2px solid #fbad25 !important"
            alt="profile photo"
            class="rounded-avatar p-25"
            width="117"
            height="117"
          />
          <div
            class="position-absolute bottom-0 mb-75"
            v-if="userData.flag_url"
          >
            <b-img
              class="rounded-circle border"
              width="28"
              height="28"
              :src="userData.flag_url || errorImage"
              @error="setAltImg"
            />
          </div>
        </template>
      </div>
      <div class="w-100 d-flex justify-content-center align-items-center pb-25">
        <b-skeleton v-if="loading" width="120px" height="30px" />
        <h3 class="text-white mb-0" v-else>
          {{ userData.first_name + " " + userData.last_name }}
        </h3>
      </div>
      <div class="w-100 pb-25">
        <b-skeleton v-if="loading" width="100px" height="20px" />
        <div v-else class="d-flex justify-content-center align-items-center">
          <p class="h5 mb-0 mr-50 pt-50">
            {{ userData.email }}
          </p>
          <b-badge
            v-if="userData.email_verified"
            variant="warning"
            class="rounded-circle p-25"
          >
            <feather-icon icon="CheckIcon" style="width: 12px; height: 12px" />
          </b-badge>
        </div>
      </div>
      <div class="w-100 mb-2 mt-3">
        <div
          class="d-flex justify-content-between bg-secondary rounded-lg py-1"
          style="border: 1px dashed #ffffff1c"
        >
          <div
            class="d-flex flex-column col-4 px-50"
            style="border-right: 1px dashed #ffffff1c"
          >
            <b-skeleton v-if="loadingDashboard" width="80px" height="30px" />
            <span class="text-white h1 mb-0" v-else>
              {{ userData.rank || "0" }}
            </span>
            <small>Trader ranking</small>
          </div>
          <div
            class="d-flex flex-column col-4 px-50"
            style="border-right: 1px dashed #ffffff1c"
          >
            <b-skeleton v-if="loadingDashboard" width="80px" height="30px" />
            <span class="text-white h1 mb-0" v-else>
              {{ userData.attended_competitions || "0" }}
            </span>
            <small>Attended competitions</small>
          </div>
          <div class="d-flex flex-column col-4 px-50">
            <b-skeleton v-if="loadingDashboard" width="80px" height="30px" />
            <div class="text-white h1 text-truncate mb-0" v-else>
              {{ fromNow(toLocal(userData.email_verified_at)) || "-" }}
            </div>
            <small>Since first login</small>
          </div>
        </div>
      </div>
      <div class="w-100">
        <b-button
          :to="{ name: 'users-edit-profile' }"
          block
          class="d-flex justify-content-center align-items-center text-muted py-75"
        >
          <feather-icon
            icon="Edit3Icon"
            class="mr-50"
            style="width: 15px; height: 15px"
          />
          <small>Edit profile</small>
        </b-button>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BButton,
  BAvatar,
  BRow,
  BCol,
  BImg,
  VBTooltip,
  BBadge,
  BSkeleton,
} from "bootstrap-vue";
export default {
  components: {
    BCard,
    BCardBody,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BImg,
    BBadge,
    BSkeleton,
  },
  props: {
    loadingDashboard: {
      type: Boolean,
      default: false,
    },
    dashboard: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      loading: false,
    };
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  async created() {
    this.loading = true;
    await this.getProfile();
    this.loading = false;
  },
  methods: {
    async getProfile() {
      try {
        const { data } = await this.$http.get("panel/profile/user");
        await localStorage.setItem(
          "userData",
          JSON.stringify({
            ...data.user,
            email_verified: data.user.email_verified_at
              ? true
              : this.userData.email_verified,
            type: data.abilities[0].includes("admin") ? "admin" : "user",
          })
        );
        await this.$store.dispatch("auth/setUserData", {
          ...data.user,
          email_verified: data.user.email_verified_at
            ? true
            : this.userData.email_verified,
          type: data.abilities[0].includes("admin") ? "admin" : "user",
        });
        this.userData = {
          ...data.user,
          email_verified: data.user.email_verified_at
            ? true
            : this.userData.email_verified,
          type: data.abilities[0].includes("admin") ? "admin" : "user",
        };
        if (data.needChangeAccount && data.needChangeAccount.length) {
          this.$emit("showChangeAccountModal", data.needChangeAccount);
        }
      } catch (err) {}
    },
  },
};
</script>
